import Instructions from "../modules/Instructions";
import ModeChoices from "../modules/ModeChoices";
import { Mode } from "../types/Types";

interface HomeProps {
  startGame: () => void;
  mode: string;
  setMode: (mode: Mode) => void;
}

const Home: React.FC<HomeProps> = ({startGame, mode, setMode}) => {
  return (
    <>
      {/* Title */}
      <h1 className='text-secondary font-black text-6xl mt-20'>ColorLink</h1>

      {/* Logo */}
      <img className='w-[120px] mt-10' src="/logo.svg" alt="" />
      
      {/* Instructions */}
      <Instructions />

      {/* Mode Choice */}
      <ModeChoices mode={mode} setMode={setMode} />

      {/* Start Game */}
      <button onClick={startGame} className='mb-10 bg-cl-a px-20 py-3 rounded-xl text-secondary font-extrabold mt-3'>Start</button>
    </>
  );
}
 
export default Home;
